module.exports = __webpack_public_path__ + "static/img/jinbi-regular.dcef90a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jinbi-regular.png
// module id = UpkB
// module chunks = 9